export default "__VITE_ASSET__c860cf4b__"